import styled, { css } from 'styled-components';
import { Modal as AntdModal } from 'antd';
import theme from 'styles/theme';

type ModalProps = {
  backgroundImage: string;
  videoActive: boolean;
};

const modalModifiers = {
  isVideoActive: css`
    top: -70px;
    right: calc(50% - 24px);

    @media (max-width: 992px) {
      top: -70px;
      right: calc(50% - 24px);
    }
  `,
};

export const Modal = styled(AntdModal)<ModalProps>`
  ${({ backgroundImage, videoActive }) => css`
    position: relative;

    .ant-modal-content {
      height: 480px;
      border-radius: 8px;

      background: url(${backgroundImage});
      background-repeat: no-repeat;
      background-position-x: center;
      background-position-y: center;
      background-size: cover;

      ${videoActive &&
      css`
        border-radius: 0;
        padding: 0;
        margin: 0;
        width: 100%;
        background: transparent;
        box-shadow: none;
      `}

      @media (max-width: 992px) {
        background-size: cover;
      }
    }

    .ant-modal-body {
      padding: 96px 0 0 76px;

      @media (max-width: 992px) {
        padding: 56px 0 0 40px;
      }

      @media (max-width: 600px) {
        height: 100%;
      }
    }

    .ant-modal-close {
      top: 40px;
      right: 24px;
      z-index: 5;

      @media (max-width: 992px) {
        top: 24px;
        right: 16px;
      }

      ${videoActive && modalModifiers.isVideoActive}
    }

    .ant-modal-close-x {
      width: 44px;
      height: 44px;

      @media (max-width: 992px) {
        width: 48px;
        height: 48px;
      }
    }
  `}
`;

export const CloseButton = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;

    width: 48px;
    height: 48px;
    background-color: ${theme.colors.neutralGray10};

    border-radius: 50%;
    border: 0;
    margin: 0;
    opacity: 0.5;

    cursor: pointer;

    @media (max-width: 992px) {
      width: 48px;
      height: 48px;

      svg {
        width: 24px;
        height: 24px;
      }
    }
  `}
`;

export const TextContainer = styled.div`
  ${({ theme }) => css`
    margin-right: 96px;

    p {
      font-weight: 900;
      font-size: 5.6rem;
      line-height: 6.2rem;
      color: ${theme.colors.globalWhite100};

      margin-bottom: 24px;
    }

    span {
      font-weight: 400;
      font-size: 2rem;
      line-height: 1.6rem;
      color: ${theme.colors.globalWhite100};
    }

    @media (max-width: 992px) {
      p {
        font-size: 4.8rem;
        line-height: 5.6rem;
      }

      span {
        font-size: 2rem;
      }
    }

    @media (max-width: 600px) {
      p {
        font-size: 3.2rem;
        line-height: 3.6rem;
      }

      span {
        font-size: 1.6rem;
      }
    }
  `}
`;

export const Content = styled.div`
  display: flex;

  @media (max-width: 992px) {
    flex-direction: column;
  }

  @media (max-width: 600px) {
    justify-content: center;
    align-items: center;
    height: 100%;
  }
`;

export const PlayButtonContainer = styled.div`
  margin-top: auto;

  @media (max-width: 992px) {
    margin: auto 32px 0 auto;
  }

  @media (max-width: 600px) {
    margin-top: 16px;
  }
`;

export const IFrame = styled.div`
  /* position: relative;
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9; */

  iframe {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
  }
`;
